// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"142":"b8dff886","320":"ec3ae248","329":"933ab010","535":"d15383e2","922":"56a434c8","991":"3b5e844d"}[chunkId] + ".chunk.css";
};